import * as React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';

const ConfidenceIndicator = ({ value }) => {
  // If value is NaN, return a dash
  if (value === undefined || value === 0 || Number.isNaN(Math.round(value))) {
    return (
      <Typography variant="caption" component="div" color="text.secondary">
        -
      </Typography>
    );
  }

  const getColor = (p) => {
    if (p > 80) {
      return 'success'; // Green color for values above 80
    }
    if (p > 50) {
      return 'warning'; // Yellow color for values between 50 and 80
    }
    return 'error'; // Red color for values below or equal to 50
  };

  if (value === 100) {
    return <Person color="info" />;
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" color={getColor(value)} value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.floor(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfidenceIndicator;
